import { render, staticRenderFns } from "./Simulacros.vue?vue&type=template&id=0996934f&"
import script from "./Simulacros.vue?vue&type=script&lang=js&"
export * from "./Simulacros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports